var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8741 3.57344L21.1746 18.5143C21.5449 19.1808 21.063 20 20.3005 20H3.6995C2.93701 20 2.45505 19.1808 2.82534 18.5143L11.1258 3.57344C11.5068 2.88763 12.4931 2.88763 12.8741 3.57344ZM9.53031 10.4696C9.23742 10.1767 8.76255 10.1767 8.46965 10.4696C8.17676 10.7625 8.17676 11.2374 8.46965 11.5303L10.9393 14L8.46965 16.4696C8.17676 16.7625 8.17676 17.2374 8.46965 17.5303C8.76255 17.8232 9.23742 17.8232 9.53031 17.5303L12 15.0606L14.4697 17.5303C14.7625 17.8232 15.2374 17.8232 15.5303 17.5303C15.8232 17.2374 15.8232 16.7625 15.5303 16.4696L13.0606 14L15.5303 11.5303C15.8232 11.2374 15.8232 10.7625 15.5303 10.4696C15.2374 10.1767 14.7625 10.1767 14.4697 10.4696L12 12.9393L9.53031 10.4696Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle3);
export default __webpack_public_path__ + "static/media/triangle-3.d58c1fd606db4c64104080890b8f30c5.svg";
export { ForwardRef as ReactComponent };